import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { InputElementBase } from '../utils/types';
import { SelectOptions } from '@/data/types';

export function SelectInput({
  label,
  description,
  disabled,
  placeholder,
  name,
  onChange,
  ref,
  value,
  className,
  selectOptions,
}: Exclude<InputElementBase, 'icon' | 'type' | 'className'> & {
  selectOptions: SelectOptions;
}) {
  return (
    <FormItem ref={ref}>
      {label && <FormLabel>{label}</FormLabel>}
      <Select
        disabled={disabled || undefined}
        onValueChange={onChange}
        defaultValue={value ? String(value) : undefined}
        name={name}
      >
        <FormControl>
          <SelectTrigger className={className || undefined}>
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          <SelectGroup>
            {selectOptions.map((option) => (
              <SelectItem
                key={option.value}
                value={option.value}
                disabled={option.disabled}
              >
                {option.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>

      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
}
